import { authTypes } from "./auth.types";

const INITIAL_STATE = {
  isLoggedInUser: !!localStorage.getItem("raychat_web_app_is_user_logged_in"),
  isLoadingLogin: false,
  isLoadingResetPass: false,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case authTypes.SET_IS_LOGGED_IN_USER:
      if (action.payload)
        localStorage.setItem(
          "raychat_web_app_is_user_logged_in",
          action.payload
        );
      else localStorage.removeItem("raychat_web_app_is_user_logged_in");
      return {
        ...state,
        isLoggedInUser: action.payload,
      };

    case authTypes.SET_LOGIN_LOADING:
      return {
        ...state,
        isLoadingLogin: action.payload,
      };

    case authTypes.SET_RESET_PASSWORD_lOADING:
      return {
        ...state,
        isLoadingResetPass: action.payload,
      };

    default:
      return state;
  }
};

export default authReducer;
